module.exports = "//img1.rrcimg.com/_next/static/src/assets/default-car_FIKTT.png";